// @ts-nocheck

export const localeCodes =  [
  "en",
  "ru",
  "ka"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_main_46json_48e910f3",
      load: () => import("#nuxt-i18n/48e910f3" /* webpackChunkName: "locale_main_46json_48e910f3" */),
      cache: true
    },
    {
      key: "locale_common_46json_364cfaa7",
      load: () => import("#nuxt-i18n/364cfaa7" /* webpackChunkName: "locale_common_46json_364cfaa7" */),
      cache: true
    },
    {
      key: "locale_comingsoon_46json_36fb2bb1",
      load: () => import("#nuxt-i18n/36fb2bb1" /* webpackChunkName: "locale_comingsoon_46json_36fb2bb1" */),
      cache: true
    },
    {
      key: "locale_booking_46json_046286f1",
      load: () => import("#nuxt-i18n/046286f1" /* webpackChunkName: "locale_booking_46json_046286f1" */),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_main_46json_4863863d",
      load: () => import("#nuxt-i18n/4863863d" /* webpackChunkName: "locale_main_46json_4863863d" */),
      cache: true
    },
    {
      key: "locale_common_46json_e9bbb441",
      load: () => import("#nuxt-i18n/e9bbb441" /* webpackChunkName: "locale_common_46json_e9bbb441" */),
      cache: true
    },
    {
      key: "locale_comingsoon_46json_23354675",
      load: () => import("#nuxt-i18n/23354675" /* webpackChunkName: "locale_comingsoon_46json_23354675" */),
      cache: true
    },
    {
      key: "locale_booking_46json_472b77dc",
      load: () => import("#nuxt-i18n/472b77dc" /* webpackChunkName: "locale_booking_46json_472b77dc" */),
      cache: true
    }
  ],
  ka: [
    {
      key: "locale_main_46json_5578d5e8",
      load: () => import("#nuxt-i18n/5578d5e8" /* webpackChunkName: "locale_main_46json_5578d5e8" */),
      cache: true
    },
    {
      key: "locale_common_46json_1eda7b90",
      load: () => import("#nuxt-i18n/1eda7b90" /* webpackChunkName: "locale_common_46json_1eda7b90" */),
      cache: true
    },
    {
      key: "locale_comingsoon_46json_1b1ed210",
      load: () => import("#nuxt-i18n/1b1ed210" /* webpackChunkName: "locale_comingsoon_46json_1b1ed210" */),
      cache: true
    },
    {
      key: "locale_booking_46json_e28b7be6",
      load: () => import("#nuxt-i18n/e28b7be6" /* webpackChunkName: "locale_booking_46json_e28b7be6" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    language: "en",
    name: "English"
  },
  {
    code: "ru",
    language: "ru",
    name: "Русский"
  },
  {
    code: "ka",
    language: "ka",
    name: "ქართული"
  }
]

